import { render, staticRenderFns } from "./4.vue?vue&type=template&id=6c3c4cf8&"
import script from "./4.vue?vue&type=script&lang=js&"
export * from "./4.vue?vue&type=script&lang=js&"
import style0 from "./4.vue?vue&type=style&index=0&id=6c3c4cf8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports